import {
  WEB_CHECKOUT,
  WEB_CHECKOUT_FAILURE,
  WEB_CHECKOUT_SUCCESS,
} from './action';

const initialState = {
  loading: false,
  data: null,
  error: '',
};

const webCheckoutReducer = (state = initialState, action) => {
  switch (action.type) {
    case WEB_CHECKOUT:
      return { ...state, loading: true, error: '' };
    case WEB_CHECKOUT_SUCCESS:
      return { ...state, loading: false, data: action.payload, error: '' };
    case WEB_CHECKOUT_FAILURE:
      return { ...state, loading: false, data: null, error: action.payload };
    default:
      return state;
  }
};

export default webCheckoutReducer;
